document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".header-revamp");
  const section = document.getElementById("shopify-section-header-revamp");
  const menuButton = document.getElementById("mobile-menu-button");
  const drawer = document.querySelector(".header-revamp-drawer");
  const cartCountEl = document.getElementById("header-revamp-cart-count");
  const navLinks = document.querySelectorAll('.header-revamp-drawer-nav-link');
  const menuItems = document.querySelectorAll('.header-revamp-menu > ul > li');

  // Sticky Header
  let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const threshold = 70;
  if (header) {
    window.addEventListener("scroll", () => {
      const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (currentScrollTop > threshold) {
        header.classList.toggle("header-revamp-hidden", currentScrollTop > lastScrollTop);
      }

      lastScrollTop = Math.max(currentScrollTop, 0);
    }, { passive: true });

    // Maintain layout spacing
    if (section) {
      section.style.paddingBottom = `${header.offsetHeight}px`;
      drawer.style.height = `calc(100vh - ${header.offsetHeight}px)`;
      drawer.style.top = `${header.offsetHeight}px`;
    }
  }

  // Mobile Drawer Toggle
  if (menuButton && drawer) {
    menuButton.addEventListener("click", () => {
      drawer.classList.toggle("header-revamp-drawer-open");
      menuButton.classList.toggle("active");
      document.body.classList.toggle("no-scroll");
    });
  }

  // Hover Menu Expansion
  menuItems.forEach(item => {
    const block = item.querySelector('.header_revamp-mega-menu');
    if (block) {
      item.addEventListener('mouseenter', () => {
        block.style.height = `${block.scrollHeight}px`;
      });

      item.addEventListener('mouseleave', () => {
        block.style.height = `${block.scrollHeight}px`;
        requestAnimationFrame(() => {
          block.style.height = '0px';
        });
      });
    }
  });

  // Mobile Nav Submenu Toggle
  navLinks.forEach(link => {
    link.addEventListener('click', function () {
      const parentLi = this.closest('li');
      const submenu = this.nextElementSibling;

      if (!submenu?.classList.contains('header-revamp-drawer-nav-submenu')) return;

      // Close other open submenus
      parentLi.parentElement.querySelectorAll('.header-revamp-drawer-nav-submenu.active').forEach(el => {
        if (el !== submenu) el.classList.remove('active');
      });

      parentLi.parentElement.querySelectorAll('li.active').forEach(li => {
        if (li !== parentLi) li.classList.remove('active');
      });

      submenu.classList.toggle('active');
      parentLi.classList.toggle('active');
    });
  });

  // Cart Count Update via Rebuy
  function updateCartCount(cart) {
    if (cartCountEl && cart?.item_count !== undefined) {
      cartCountEl.textContent = cart.item_count;
    }
  }
  document.addEventListener('rebuy:cart.ready', e => updateCartCount(e.detail.cart));
  document.addEventListener('rebuy:cart.change', e => updateCartCount(e.detail.cart));
});